export default __webpack_public_path__ + "static/PAPC_Cash_Games-509ea4b7efab362885f1138dd90c81d3.pdf";